import React from 'react';
import { Search, Bell, TrendingUp, Compass, PieChart, Activity, User, Play } from 'lucide-react';
import { IMAGES } from '../data/mock';
import logo from '../assets/farmway-logo.png';

function PhoneScreen() {
  return (
    <div className="relative mx-auto w-[300px] rounded-[2.6rem] border border-white/10 bg-farmway-green-dark p-3 shadow-[0_40px_90px_-30px_rgba(0,0,0,0.8)]">
      <div className="overflow-hidden rounded-[2rem] bg-gradient-to-b from-farmway-green-mid to-farmway-green-dark">
        {/* status bar */}
        <div className="flex items-center justify-between px-6 pb-1 pt-3 text-[11px] font-semibold text-farmway-cream/80">
          <span>9:41</span>
          <span className="h-3 w-10 rounded-full bg-white/15" />
        </div>
        {/* app header */}
        <div className="flex items-center justify-between px-5 py-3">
          <div className="flex items-center gap-2">
            <img src={logo} alt="" className="h-7 w-7 rounded-md object-cover" />
            <span className="font-display text-sm font-extrabold tracking-widest text-farmway-cream">FARMWAY</span>
          </div>
          <div className="grid h-7 w-7 place-items-center rounded-full bg-farmway-gold">
            <Bell className="h-3.5 w-3.5 text-farmway-green" />
          </div>
        </div>
        {/* stats */}
        <div className="mx-4 rounded-2xl bg-white/5 p-4">
          <div className="grid grid-cols-3 gap-2 text-farmway-cream/60">
            <div>
              <p className="text-[9px] uppercase tracking-wider">Country</p>
              <p className="font-display text-sm font-bold text-farmway-cream">Georgia</p>
            </div>
            <div>
              <p className="text-[9px] uppercase tracking-wider">Land size</p>
              <p className="font-display text-sm font-bold text-farmway-cream">768 ha</p>
            </div>
            <div>
              <p className="text-[9px] uppercase tracking-wider">Yield</p>
              <p className="flex items-center gap-1 font-display text-sm font-bold text-farmway-leaf-bright">
                <TrendingUp className="h-3 w-3" />+4.4%
              </p>
            </div>
          </div>
          <svg viewBox="0 0 200 40" className="mt-3 h-8 w-full">
            <polyline
              points="0,32 25,28 50,30 75,20 100,24 125,14 150,16 175,8 200,6"
              fill="none"
              stroke="#8BC53F"
              strokeWidth="2.5"
              strokeLinecap="round"
            />
          </svg>
        </div>
        {/* project card */}
        <div className="px-4 pt-4">
          <p className="mb-2 font-display text-xs font-semibold uppercase tracking-widest text-farmway-cream/70">Projects</p>
          <div className="overflow-hidden rounded-2xl bg-white/5">
            <div className="relative h-24">
              <img src={IMAGES.rollingHills} alt="" className="h-full w-full object-cover" />
              <div className="absolute inset-0 grid place-items-center bg-farmway-green-dark/30">
                <span className="grid h-9 w-9 place-items-center rounded-full bg-farmway-gold">
                  <Play className="h-4 w-4 fill-farmway-green text-farmway-green" />
                </span>
              </div>
            </div>
            <div className="p-3">
              <p className="font-display text-sm font-bold text-farmway-cream">Hickory Farm</p>
              <p className="text-[11px] text-farmway-cream/60">Kakheti, Georgia</p>
              <div className="mt-3 grid grid-cols-2 gap-2">
                <span className="rounded-full bg-farmway-gold py-1.5 text-center font-display text-[11px] font-bold uppercase tracking-wide text-farmway-green">Buy</span>
                <span className="rounded-full border border-white/20 py-1.5 text-center font-display text-[11px] font-bold uppercase tracking-wide text-farmway-cream">Sell</span>
              </div>
            </div>
          </div>
        </div>
        {/* bottom nav */}
        <div className="mt-4 flex items-center justify-around border-t border-white/10 px-4 py-3 text-farmway-cream/50">
          {[{ i: Compass, l: 'Discover', a: true }, { i: PieChart, l: 'Portfolio' }, { i: Activity, l: 'Activity' }, { i: User, l: 'Account' }].map((n) => (
            <div key={n.l} className={`flex flex-col items-center gap-1 ${n.a ? 'text-farmway-gold' : ''}`}>
              <n.i className="h-4 w-4" />
              <span className="text-[9px]">{n.l}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function PlatformPreview() {
  return (
    <div className="relative">
      <div className="absolute -left-6 top-10 hidden animate-float rounded-2xl border border-white/10 bg-farmway-green-mid/80 p-4 backdrop-blur-md md:block">
        <div className="flex items-center gap-2">
          <Search className="h-4 w-4 text-farmway-gold" />
          <span className="text-xs text-farmway-cream/80">Discover 40+ projects</span>
        </div>
      </div>
      <div className="absolute -right-4 bottom-16 hidden animate-float rounded-2xl border border-white/10 bg-farmway-green-mid/80 p-4 backdrop-blur-md md:block" style={{ animationDelay: '1.5s' }}>
        <p className="font-display text-xl font-black text-farmway-gold">16.2%</p>
        <p className="text-[10px] uppercase tracking-wider text-farmway-cream/60">Target Net IRR</p>
      </div>
      <PhoneScreen />
    </div>
  );
}
